import { render, staticRenderFns } from "./addNewProduct.vue?vue&type=template&id=700c1e8a&scoped=true"
import script from "./addNewProduct.vue?vue&type=script&lang=js"
export * from "./addNewProduct.vue?vue&type=script&lang=js"
import style0 from "./addNewProduct.vue?vue&type=style&index=0&id=700c1e8a&prod&lang=scss&scoped=true"
import style1 from "./addNewProduct.vue?vue&type=style&index=1&id=700c1e8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700c1e8a",
  null
  
)

export default component.exports